import styled from "styled-components";
import { Tag, Select } from "antd";
import house from "../../../../assets/imgs/house.jpg";

const { Option } = Select;

export const Container = styled.div`
  width: 100%;
  padding: 60px;
  display: flex;
  flex-direction: column;
  background-color: #f6f8f9;
`;

Container.Select = styled(Select)``;
Container.Option = styled(Option)``;

Container.Save = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background: #0061df;
  border-radius: 3px;
  width: 260px;
  height: 55px;
  font-weight: 600;
  font-size: 13px;
  line-height: 17px;
  text-transform: uppercase;
  color: #ffffff;
  letter-spacing: 0.8px;
  margin-top: 30px;
  margin-left: auto;
  cursor: pointer;
`;

export const Title = styled.div`
  font-style: normal;
  font-weight: 600;
  font-size: 30px;
  line-height: 38px;
  color: #0d263b;
`;

Title.Text = styled.div`
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 18px;
  color: #696969;
`;

Container.Box = styled.div`
  background: var(--colorWhite);
  border: 1px solid #e6e9ec;
  box-shadow: 0px 10px 30px rgba(13, 38, 59, 0.05);
  border-radius: 3px;
  padding: 30px;

  margin-top: 30px;
`;

Container.Title = styled.div`
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 20px;
  color: #0d263b;
  margin-bottom: 30px;
  margin-top: ${({ mrTop }) => (mrTop ? mrTop : "")};
`;

export const Input = styled.input`
  /* width: ${({ w30 }) => (w30 ? "32.2%" : "100%")}; */
  padding: 9px 0;
  box-sizing: border-box;
  border: none;
  border-bottom: 2px solid #e6e9ec;
  :focus {
    outline: none;
    border-bottom: 2px solid var(--colorBlue);
  }
  ::placeholder {
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 18px;
    color: #bfbfbf;
  }
`;

export const Wrap = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 1em;
`;

Input.Title = styled.div`
  font-style: normal;
  font-weight: 600;
  font-size: 13px;
  line-height: 17px;
  color: #0d263b;
`;

Input.Wrap = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: end;
  width: 100%;
  margin-right: ${({ mr }) => mr && "1.875em"};
  height: 64px;
`;

export const TextArea = styled.textarea`
  height: 80px;
  width: 100%;
  padding: 20px 0;
  border: none;
  border-bottom: 2px solid #e6e9ec;
  :focus {
    outline: none;
    border-bottom: 2px solid var(--colorBlue);
  }

  ::placeholder {
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 18px;
    color: #bfbfbf;
  }
`;

export const UploadInput = styled.input`
  overflow: hidden;
  display: none;
`;

export const Label = styled.label`
  border: 1px solid #ccc;
  display: inline-block;
  padding: 7px 15px;
  cursor: pointer;
  background-color: var(--colorWhite);

  border: 1px solid #0061df;
  box-sizing: border-box;
  border-radius: 3px;
  width: 170px;
  height: 55px;

  display: flex;
  align-items: center;
  justify-content: center;

  font-style: normal;
  font-weight: 600;
  font-size: 13px;
  line-height: 17px;
  text-transform: uppercase;
  color: #0061df;

  overflow: hidden;
  margin-top: 15px;
  margin-bottom: 20px;
`;

export const GoogleMapWrap = styled.div`
  width: 100%;
  height: 480px;
  margin-top: 30px;
`;

export const Cancelimg = styled(Tag)`
  width: 170px;
  height: 150px;
  background: #c4c4c4;
  border-radius: 3px;
  overflow: hidden;
  position: relative;
  :hover .anticon {
    visibility: visible;
    transition: 0.3s ease-in-out;
  }

  padding: 0;
  margin-top: 19px;
  margin-right: 15px;
`;

Cancelimg.Wrap = styled.div`
  display: flex;
  flex-direction: column;

  .anticon {
    path {
      fill: #0d263b;
    }
    visibility: hidden;
    position: absolute;
    right: 12px;
    top: 12px;
    background-color: var(--colorWhite);
    border: 1px solid #e6e9ec;
    box-sizing: border-box;
    padding: 10px;
    border-radius: 50%;
    box-shadow: 0px 10px 50px rgba(13, 38, 59, 0.1);
  }
`;

Cancelimg.Img = styled.img.attrs({
  src: house,
})`
  width: 100%;
`;
